import { Breadcrumb as AntdBreadcrumb } from "antd";
import { useTranslation } from 'react-i18next';

const Breadcrumb = () => {
  const { t } = useTranslation();
  return (
    <AntdBreadcrumb
      className="mb-20"
      separator="-"
      items={[
        {
          title: t('common.home'),
          href: "/",
        },
        {
          title: t('common.catalog'),
          href: "/catalog",
        },
        {
          title: t('common.category'),
        },
      ]}
    />
  )
};

export default Breadcrumb;
